import { MAX_GROUP_HISTORY } from './constants';

interface OrderStore {
  getOrder: () => number;
  incOrder: () => void;
  getGroupOrder: () => number;
  incGroupOrder: () => void;
  getIdsToRemove: () => number | undefined;
}

function createOrderStore(): OrderStore {
  let order = 1;
  const orderList: number[] = [];
  let groupOrder = 1;
  const groupOrderList = [groupOrder];

  return {
    getOrder: () => order,
    incOrder: () => {
      order++;
      orderList.push(order);
    },
    getGroupOrder: () => groupOrder,
    incGroupOrder: () => {
      groupOrder++;
      groupOrderList.push(groupOrder);
    },
    getIdsToRemove: () => {
      if (groupOrderList.length > MAX_GROUP_HISTORY) {
        return groupOrderList.shift();
      }
    },
  };
}

// 싱글톤 인스턴스
export const orderStore = createOrderStore();
